export interface DefaultValues {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  countryCodeId: string;
  homeLocation: {
    text: string;
    value?: string | number;
  };
}

export enum ErrorKey {
  UNSAVED = 'unsaved',
  NETWORK = 'network',
}
